import { AuthMenuService } from './menu/auth-menu.service';
import { AuthGuard } from './auth.guard';
import { AuthService } from './auth-service.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeModule } from '../@theme/theme.module';
import { AuthRoutingModule, routedComponents } from './auth-routing.module';
import { AuthLoginComponent } from './auth-login/auth-login.component';
import { AuthComponent } from './auth.component';
import { environment } from '../../environments/environment';
import { HasClaimDirective } from './has-claim.directive';
import { HasRoleDirective } from './has-role.directive';
import { SecurePipe } from './secure.pipe';
import { AuthForgetComponent } from './auth-forget/auth-forget.component';
import { AuthResetComponent } from './auth-reset/auth-reset.component';
import { NbCardModule, NbLayoutModule, NbSpinnerModule } from '@nebular/theme';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HasCustomerRoleDirective } from './has-customer-role.directive';
import { LocalizationModule } from '../@core/localization/localization.module';
import { MfaService } from './mfa-service';
import { QRCodeModule } from 'angularx-qrcode';

export function tokenGetter() {
  return localStorage.getItem(environment.DEFAULT_TOKEN_NAME);
}

@NgModule({
  imports: [
    CommonModule,
    ThemeModule,
    AuthRoutingModule,
    NbLayoutModule,
    NbCardModule,
    ReactiveFormsModule,
    FormsModule,
    NbSpinnerModule,
    LocalizationModule,
    QRCodeModule
  ],
  declarations: [AuthLoginComponent, ...routedComponents, AuthComponent, HasClaimDirective, HasRoleDirective, SecurePipe, AuthForgetComponent, AuthResetComponent, HasCustomerRoleDirective],
  providers: [
    AuthService,
    AuthGuard,
    AuthMenuService,
    MfaService
    //{ provide: HTTP_INTERCEPTORS, useClass: AuhtHttpInterceptor, multi: true }
  ],
  exports: [HasClaimDirective, HasRoleDirective, SecurePipe, HasCustomerRoleDirective]
})

export class AuthModule { }
